<template>
  <StageAdditionalAgreementForm
    ref="form"
    :disabled="disabled"
    mode="automation"
    :value.sync="valueMutable"/>
</template>
<script>
import StageAdditionalAgreementForm from 'components/agreement/StageAdditionalAgreementForm.vue'
import textFunctions from 'mixins/textFunctions'

export default {
  name: 'startAdditionalApprovals',
  mixins: [ textFunctions ],
  methods: {
    /**
     * Метод вызывается перед отправкой формы автоматизации
     * Имя метода стандартное и не изменное
     */
    async beforeApply() {
      await this.$refs.form.createRules()
      this.$nextTick(async () => {
        await this.$refs.form.$refs.addAgreeingForm.validate(async (valid) => {
          if (valid) {
            const clearProp = this.$_.cloneDeep(this.valueMutable)
            clearProp.stages.forEach((stage) => {
              delete stage.editObject
              delete stage.disable
              delete stage.activeStatus
              stage.agreements.forEach((contact) => {
                delete contact.edit
              })
            })
            this.valueMutable = clearProp
            this.$emit('changeValidateResult', {type: 'startAdditionalApprovals', result: true})
          } else {
            this.$emit('changeValidateResult', {type: 'startAdditionalApprovals', result: false})
          }
        })
      })
    },
  },
  computed: {
    valueMutable: {
      get() {
        const defaultMode = {
          comment: '',
          moveTenderAfterAgreeSucceeded: false,
          isCancelTenderAfterReject: false,
          stages: []
        }
        if (!this.value?.parameters) {
          return defaultMode
        }
        try {
          let result = JSON.parse(this.value.parameters) || defaultMode

          result = Object.keys(result).length === 0 ? defaultMode : this.$_formatObjectProperty(result, 'lowercaseFirstLetter')
          result.moveTenderAfterAgreeSucceeded = result.moveTenderAfterAgreeSucceeded === true || result.moveTenderAfterAgreeSucceeded === 'true'
          result.isCancelTenderAfterReject = result.isCancelTenderAfterReject === true || result.isCancelTenderAfterReject === 'true'
          return result
        } catch (e) {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: this.$t('Automation.ErrorActionParams'),
            showClose: true,
            progress: true,
          })
          return defaultMode
        }
      },
      set(newParameters) {
        let result = this.$_.cloneDeep(this.value)

        newParameters = this.$_formatObjectProperty(newParameters, 'capitalizeFirstLetter')

        result.parameters = JSON.stringify(newParameters)
        this.$emit('update:value', result)
      }
    },
  },
  components: {
    StageAdditionalAgreementForm
  },
  mounted() {
    if (!this.valueMutable?.stages?.length) {
      this.$refs.form?.addedStage()
    }
    this.$refs.form?.createRules()
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    additionalProps: {
      type: [Object, Array]
    },
  },
}
</script>
